import { render } from "./TestResultGrid.vue?vue&type=template&id=de7c2662&scoped=true&ts=true"
import script from "./TestResultGrid.vue?vue&type=script&lang=ts"
export * from "./TestResultGrid.vue?vue&type=script&lang=ts"

import "./TestResultGrid.vue?vue&type=style&index=0&id=de7c2662&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de7c2662"]])

export default __exports__